import { BACKGROUND_TEXT_MODE } from '../../../constants';
import type { TextElement } from '../../types';

export function getStandardHighlightHeight({
  backgroundTextMode,
  highlightElement,
  verticalTrim,
}: {
  backgroundTextMode: TextElement['backgroundTextMode'];
  highlightElement: HTMLElement | null;
  verticalTrim: TextElement['verticalTrim'];
}) {
  if (
    backgroundTextMode !== BACKGROUND_TEXT_MODE.HIGHLIGHT ||
    verticalTrim === 'baseline' ||
    !highlightElement
  ) {
    return null;
  }

  const lineBands = Array.from(
    highlightElement.querySelectorAll<HTMLElement>('[data-st-text-line-band]')
  );
  if (lineBands.length === 0) {
    return highlightElement.offsetHeight;
  }

  // The outer inline has a zero line-height so it does not add a fallback
  // font strut to mixed-size text. Its own offsetHeight therefore covers only
  // the first line. Measure the visible bands in local (untransformed)
  // coordinates instead, including the line-height gap between them.
  const top = Math.min(...lineBands.map((line) => line.offsetTop));
  const bottom = Math.max(
    ...lineBands.map((line) => line.offsetTop + line.offsetHeight)
  );
  return Math.max(0, bottom - top);
}
